export function normalizeWorkspaceUser(item) {
  return {
    workspaceUserId: item.user_id,
    userId: item.user?.id ?? item.user_id,
    name: item.user?.name || "—",
    email: item.user?.email || "",
    role: item.role,
    status: item.status,
    reportsToUserId: item.reports_to_user_id || null,
    reportsTo: item.reports_to?.name || null,
    reportsToEmail: item.reports_to?.email || null,
    reportsToRole: item.reports_to?.role || null,
    createdAt: item.created_at,
    updatedAt: item.updated_at,
  };
}

export function normalizeWorkspaceUsers(list) {
  return (list || []).map(normalizeWorkspaceUser);
}

/* Builds the POST /workspaces/{workspaceId}/users payload. */
export function toAddUserPayload(form) {
  return {
    email: form.email?.trim().toLowerCase(),
    role: form.role,
    reports_to_user_id: form.reportsToUserId || null,
    status: form.status,
  };
}

/** Builds the PATCH /workspaces/{workspaceId}/users/{workspaceUserId} payload. */
export function toUpdateUserPayload(form) {
  return {
    role: form.role,
    reports_to_user_id: form.reportsToUserId || null,
    status: form.status,
  };
}

export function getInitials(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

export function formatJoinedDate(dateString) {
  if (!dateString) return "—";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

/** Dynamic "Reports to" options built only from actual admins/managers in the workspace. */
export function getReportsToOptions(users) {
  const seen = new Map();
  users.forEach((u) => {
    if (u.role === "admin" || u.role === "manager") {
      seen.set(u.userId, { id: u.userId, name: u.name });
    }
  });
  return Array.from(seen.values());
}

export function filterMembers(
  users,
  { search = "", role = "all", status = "all", reportsTo = "all" } = {}
) {
  const query = search.trim().toLowerCase();

  return users.filter((u) => {
    if (query) {
      const haystack = [u.name, u.email, u.role, u.reportsTo]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      if (!haystack.includes(query)) return false;
    }
    if (role !== "all" && u.role !== role) return false;
    if (status !== "all" && u.status !== status) return false;
    if (reportsTo !== "all") {
      if (reportsTo === "none") {
        if (u.reportsToUserId) return false;
      } else if (u.reportsToUserId !== reportsTo) {
        return false;
      }
    }
    return true;
  });
}

export function paginateMembers(users, page, pageSize) {
  const start = (page - 1) * pageSize;
  return users.slice(start, start + pageSize);
}
